import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { BffService } from '../../services/BffService';
import { DualAuthService } from '../../services/DualAuthService';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-footer',
  imports: [RouterLink, MatListModule, MatIconModule, CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
})
export class FooterComponent {
  constructor(
    private router: Router, 
    private bff: BffService,
    public authService: DualAuthService
  ) {}

  navigateToEmployeeLogin(): void {
    this.bff.signInEmployee();
  }
}
